<script setup lang='ts'>
import { imageTransform } from '@qctsw/common'
import { logicHelpDetail } from '@/logic/common/help'
import { useGetRouteParam } from '@/shared/function'
import { HOME_SITE_META, SITE_NAME } from '@/shared/site'

const id = useGetRouteParam('id', '')
const {
  state,
  data,
  getHelp,
} = logicHelpDetail()

const { changeMeta } = useSite(HOME_SITE_META)
function changeMetaHandler() {
  if (!data.value)
    return
  const d = data.value
  changeMeta({
    title: `${d.title} - ${SITE_NAME}`,
  })
}
useActivatedWatch(() => [
  watch(data, changeMetaHandler, { deep: true }),
])

if (id.value && !Number.isNaN(Number(id.value))) {
  await getHelp(Number(id.value))
  changeMetaHandler()
}
</script>

<template>
  <div bg-slate-1 public-page>
    <div class="bg-white rounded-md max-w-230 m-auto px-xl py-sm ">
      <UtilLoadState :state="state" :reload-handler="() => getHelp(Number(id))">
        <div v-if="data" class=" ">
          <div class="text-5 font-bold leading-1.5em text-center">
            {{ data.title.replace("质量监管", "") }}
          </div>
          <div
            v-if="data.contentTypeCode === 1"
            class="mt-8 leading-1.3em pb-8"
          >
            <div v-html="data.content" />
          </div>
          <div v-if="data.contentTypeCode === 2" class="mt-8 leading-1.3em pb-8">
            <div class="grid grid-cols-2 gap-3">
              <div v-for=" v, i in JSON.parse(decodeURIComponent(data.content))" :key="i" class="w-full relative overflow-hidden">
                <img class="w-full h-70 object-cover" :src="imageTransform(v.imgUrl) ?? ''">
                <h5 class="text-center px-2.5 bg-black text-white  absolute bottom-0 left-0">
                  {{ v.imgTitle }}
                </h5>
              </div>
            </div>
          </div>
          <div
            v-if="data.contentTypeCode === 3"
            class="mt-8 leading-1.3em pb-8"
          >
            <div class="flex flex-wrap">
              <div
                v-for=" v, i in JSON.parse(decodeURIComponent(data.content))"
                :key="i"
              >
                <a
                  class="primary-hover link-item"
                  :href="v.linkUrl"
                >{{ v.linkTitle }}</a>
              </div>
            </div>
          </div>
        </div>
        <BasicEmpty v-else />
      </UtilLoadState>
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
